import { render, staticRenderFns } from "./DiscountDialog.vue?vue&type=template&id=9962b48e"
import script from "./DiscountDialog.vue?vue&type=script&lang=js"
export * from "./DiscountDialog.vue?vue&type=script&lang=js"
import style0 from "./DiscountDialog.vue?vue&type=style&index=0&id=9962b48e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F03-organisms%2Fdiscount-dialog%2FDiscountDialog.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports